/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Doctor_AriaInputs */

const en_faq_doc_doctor_aria = /** @type {(inputs: Faq_Doc_Doctor_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Seeing A Doctor Document`)
};

const fr_faq_doc_doctor_aria = /** @type {(inputs: Faq_Doc_Doctor_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le document Guide pour consulter un médecin`)
};

/**
* | output |
* | --- |
* | "Link to Seeing A Doctor Document" |
*
* @param {Faq_Doc_Doctor_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_doctor_aria = /** @type {((inputs?: Faq_Doc_Doctor_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Doctor_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_doctor_aria(inputs)
	return fr_faq_doc_doctor_aria(inputs)
});